import { CheckCircle, NotePencil, Notepad } from '@phosphor-icons/react'
import React, { useContext, useState } from 'react'
import { ActionCard } from '../../components/ActionCard'
import { Modal } from '../../components/Modal'
import { SideTab } from '../../components/SideTab'
import { Button } from '../../components/common/Button'
import { DefaultContent } from '../../components/common/DefaultContent'
import { ContextContracts } from '../../context/context_contracts'
import { FormEditContract } from './components/FormEditContract'
import { FormNewResidentContract } from './components/FormNewResidentContract'
import { TableResidentsContract } from './components/TableResidentContracts'
import { Body, Container, Header, Title } from './styles'

import { Helmet } from 'react-helmet'

export const ResidentsContracts = () => {
  const { createContract, sendUpdate, stopEditing, deleteContract } =
    useContext(ContextContracts)

  const [newContractState, setNewContractState] = useState(false)
  const [modalSaveNewContract, setModalSaveNewContract] = useState(false)
  const [editContractState, setEditContractState] = useState(false)
  const [modalSaveEditContract, setModalSaveEditContract] = useState(false)
  const [modalRemoveContract, setModalRemoveContract] = useState(false)

  const [modalContractSuccess, setModalContractSuccess] = useState(false)
  const [modalContractRemovedSuccess, setModalContractRemovedSuccess] =
    useState(false)

  const handlerState = (setValue) => {
    setValue((prev) => !prev)
  }

  return (
    <>
      <Helmet>
        <title>Previx - Contratos</title>
        <meta name="Previx - Contratos" content="Página de contratos" />
      </Helmet>
      <DefaultContent
        icon={<NotePencil size={26} color="#003E5F" weight="fill" />}
        title="Previx - Moradores - Contratos"
      >
        <Container>
          <Header>
            <ActionCard.Root>
              <ActionCard.Content
                onclick={() => handlerState(setNewContractState)}
                background="#52427B"
                border="#BBA7E3"
                color="#fff"
              >
                <ActionCard.Icon
                  transform={20}
                  icon={<Notepad size={60} weight="fill" color="#BBA7E3" />}
                />

                <ActionCard.Information value="Adicionar contrato" />
              </ActionCard.Content>
            </ActionCard.Root>
          </Header>
          <Body>
            <Title>Lista de contratos cadastrados na plataforma</Title>
            <TableResidentsContract openModal={setEditContractState} />
          </Body>
        </Container>

        {/* Edita contrato */}
        <SideTab
          open={editContractState}
          title="Dados do contrato"
          toggleFunction={() => handlerState(setEditContractState)}
          width="45%"
        >
          <FormEditContract
            handleModalSave={setModalSaveEditContract}
            handleModalRemove={setModalRemoveContract}
          />
        </SideTab>

        {/* salvar modificações */}
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="25%"
          height="fit-content"
          left="50%"
          top="50%"
          open={modalSaveEditContract}
          setIsOpenController={() => {
            handlerState(setModalSaveEditContract)
          }}
          padding="0 1rem 1rem"
        >
          <Modal.Header
            onclick={() => {
              handlerState(setModalSaveEditContract)
            }}
          />
          <Modal.Content
            value="Você deseja salvar?"
            subvalue="Ao clicar em salvar, você estará atualizando este contrato no sistema."
          />
          <Modal.Footer>
            <Button.Root
              backgroundColor="#fff"
              border="1px solid #770A00"
              onClick={() => {
                // stopEditing()
                handlerState(setModalSaveEditContract)
              }}
            >
              <Button.Content title="Não, cancelar" color="#770A00" />
            </Button.Root>
            <Button.Root
              backgroundColor="#067FB7"
              onClick={() => {
                sendUpdate()
                handlerState(setModalSaveEditContract)
                handlerState(setModalContractSuccess)
              }}
            >
              <Button.Content title="SALVAR" color="#fff" />
            </Button.Root>
          </Modal.Footer>
        </Modal.Root>

        {/* apagar contrato */}
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="25%"
          height="fit-content"
          left="50%"
          top="50%"
          open={modalRemoveContract}
          setIsOpenController={() => {
            handlerState(setModalRemoveContract)
          }}
          padding="0 1rem 1rem"
        >
          <Modal.Header
            onclick={() => {
              handlerState(setModalRemoveContract)
            }}
          />
          <Modal.Content
            value="Você deseja realmente deletar?"
            subvalue="Ao clicar em Deletar, você estará removendo este contrato da plataforma e possivelmente terá de atualizar o cadastro de alguns moradores."
          />
          <Modal.Footer>
            <Button.Root
              backgroundColor="#fff"
              border="1px solid #770A00"
              onClick={() => {
                stopEditing()
                handlerState(setModalRemoveContract)
              }}
            >
              <Button.Content title="Não, cancelar" color="#770A00" />
            </Button.Root>
            <Button.Root
              backgroundColor="#770A00"
              onClick={() => {
                deleteContract()
                handlerState(setModalRemoveContract)
                handlerState(setModalContractRemovedSuccess)
              }}
            >
              <Button.Content title="DELETAR" color="#fff" />
            </Button.Root>
          </Modal.Footer>
        </Modal.Root>

        {/* Criar novo contrato */}
        <SideTab
          open={newContractState}
          title="Adicionar novo contrato"
          toggleFunction={() => handlerState(setNewContractState)}
          width="45%"
        >
          <FormNewResidentContract handleModal={setModalSaveNewContract} />
        </SideTab>

        {/* salvar novo contrato */}
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="25%"
          height="fit-content"
          left="50%"
          top="50%"
          open={modalSaveNewContract}
          setIsOpenController={() => {
            handlerState(setModalSaveNewContract)
          }}
          padding="0 1rem 1rem"
        >
          <Modal.Header
            onclick={() => {
              handlerState(setModalSaveNewContract)
            }}
          />
          <Modal.Content
            value="Você deseja salvar?"
            subvalue="Ao clicar em salvar, você estará atualizando este contrato no sistema."
          />
          <Modal.Footer>
            <Button.Root
              backgroundColor="#fff"
              border="1px solid #770A00"
              onClick={() => {
                stopEditing()
                handlerState(setModalSaveNewContract)
              }}
            >
              <Button.Content title="Não, cancelar" color="#770A00" />
            </Button.Root>
            <Button.Root
              backgroundColor="#067FB7"
              onClick={() => {
                createContract()
                handlerState(setModalSaveNewContract)
                handlerState(setModalContractSuccess)
              }}
            >
              <Button.Content title="SALVAR" color="#fff" />
            </Button.Root>
          </Modal.Footer>
        </Modal.Root>

        {/* alterações salvas */}
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="fit-content"
          height="fit-content"
          left="50%"
          top="50%"
          open={modalContractSuccess}
          setIsOpenController={() => {
            handlerState(setModalContractSuccess)
          }}
          padding="0 1rem 1rem"
        >
          <Modal.Header
            onclick={() => {
              handlerState(setModalContractSuccess)
            }}
          />
          <Modal.Icon icon={<CheckCircle size={48} fill="#006598" />} />
          <Modal.Content
            value="Dados atualizados!"
            subvalue="Você atualizou um contrato"
          />
          <Modal.Footer>
            <Button.Root
              backgroundColor="#00517D"
              onClick={() => (window.location.href = '/moradores/contratos')}
            >
              <Button.Content title="Voltar para página" color="#fff" />
            </Button.Root>
          </Modal.Footer>
        </Modal.Root>

        {/* contrato deletado sucesso */}
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="fit-content"
          height="fit-content"
          left="50%"
          top="50%"
          open={modalContractRemovedSuccess}
          setIsOpenController={() => {
            handlerState(setModalContractRemovedSuccess)
          }}
          padding="0 1rem 1rem"
        >
          <Modal.Header
            onclick={() => {
              handlerState(setModalContractRemovedSuccess)
            }}
          />
          <Modal.Icon icon={<CheckCircle size={48} fill="#770A00" />} />
          <Modal.Content
            value="Contrato removido"
            subvalue="Você removeu o contrato da plataforma"
          />
          <Modal.Footer>
            <Button.Root
              backgroundColor="#770A00"
              onClick={() => (window.location.href = '/moradores/contratos')}
            >
              <Button.Content title="Voltar para página" color="#fff" />
            </Button.Root>
          </Modal.Footer>
        </Modal.Root>
      </DefaultContent>
    </>
  )
}
